/**
 * Simple component to resolve label from WordPress Template
 */
export default class ExLabel {
	constructor($scope, $rootScope, $element, $attrs, labelService) {
		'ngInject';

		let labels = {};
		this.label = "no-label-found";
		$scope.count = 1;

		$scope.$watch("this.page", () => {
			if (this.page && this.key) {
				labels = labelService.getLabelsByPage(this.page);
				this.label = labels[this.key];
			}
		});

		$rootScope.$on("labelService:labelsChanged", (event, newLabels) => {
			this.label = newLabels[this.page][this.key];
			$scope.$apply();
		});
	}
}


// WEBPACK FOOTER //
// ./src/app/components/common/exLabel/exLabel.controller.js